import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(async () => {
	const { init } = useAuth()
	const { resolvedTenant } = useTenant()

	const config = useRuntimeConfig().public
	const { environment } = useEnvironment()

	const tenant = resolvedTenant.value

	if (!isPlatform('capacitor') && tenant) {
		await init({
			url: config.keycloak.url,
			realm: tenant.realm,
			clientId: tenant.clientId,
			appRedirectUri: config.keycloak.appRedirectUri,
			redirectUri: window.location.origin,
			environment,
		})
	}
})
